<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
		<v-col class="pa-0">
            <show v-if="Object.keys(models).length"
                :id="id"
                model-def="vehicles"
                model-class="vehicle"
                :models="models"
                :infos="infos"
                :activities="true"
                :maillogs="false"
                :fileuploader="true">
                <template v-slot:relations>
                    <v-row class="ma-0" v-if="relations.expirations">
                        <belongstomany-show
                            class="pb-4"
                            :collection="relations.expirations.collection"
                            :headers="relations.expirations.info.fieldDefs"
                            title="Scadenze"
                            downloadCSV>
                            <template v-slot:table-footer>
                                <v-container class="py-3 px-3">
                                    <v-row class="pa-0 ma-0" justify="center">
                                        <v-col lg="3" md="4" sm="6" class="py-0">
                                            <v-card class="background-2" elevation="0">
                                                <v-card-text class="text-center pa-0">
                                                    <v-icon color="blue" size="28" class="mb-1">mdi-calendar-alert</v-icon>
                                                    <div class="text-caption font-weight-medium">Totale Scadenze</div>
                                                    <div style="font-size: 16px !important" class="text-h6 font-weight-bold blue--text">{{ relations.expirations.collection.length }}</div>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                        <v-col lg="3" md="4" sm="6" class="py-0">
                                            <v-card class="background-2" elevation="0">
                                                <v-card-text class="text-center pa-0">
                                                    <v-icon color="orange" size="28" class="mb-1">mdi-alert-circle</v-icon>
                                                    <div class="text-caption font-weight-medium">In Scadenza</div>
                                                    <div style="font-size: 16px !important" class="text-h6 font-weight-bold orange--text">{{ expiringCount }}</div>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                        <v-col lg="3" md="4" sm="6" class="py-0">
                                            <v-card class="background-2" elevation="0">
                                                <v-card-text class="text-center pa-0">
                                                    <v-icon color="green" size="28" class="mb-1">mdi-cash-check</v-icon>
                                                    <div class="text-caption font-weight-medium">Costo Totale</div>
                                                    <div style="font-size: 16px !important" class="text-h6 font-weight-bold green--text">{{ totalCost | currency }}</div>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </template>
                        </belongstomany-show>
                    </v-row>
                    <v-row class="ma-0" v-if="relations.statuses">
                        <belongstomany-show
                            class="pb-4"
                            :collection="relations.statuses.collection"
                            :headers="relations.statuses.info.fieldDefs"
                            title="Storico Stati">
                        </belongstomany-show>
                    </v-row>
                </template>
            </show>

        </v-col>
    </v-row>
</template>

<script>

    import BelongstomanyShow from '@/components/common/BelongstomanyShow'

    export default {
        name: 'vehicle',
        components: {
			BelongstomanyShow
        },

        props: {
            id: Number,
        },

        data() {
            return {
				infos: {},
				models: {},
				relations: {},
            }
        },

        computed: {
            totalCost() {
                if(!this.relations.expirations) return 0
                return this.relations.expirations.collection.reduce((acc, exp) => acc + (exp.cost || 0), 0)
            },
            expiringCount() {
                if(!this.relations.expirations) return 0
                return this.relations.expirations.collection.filter(exp => exp.condition === 'expiring' || exp.condition === 'expired').length
            }
        },

        methods: {
            initialization() {
                this.axios.get('vehicles/' + this.id).then(response => {
                    this.$set(this, 'models', response.data.models)
                    this.$set(this, 'infos', response.data.infos)
                    this.$set(this, 'relations', response.data.relations)
                    this.$store.commit('endProgress')

                }, response => {
                    // error callback
                })
            }
        },

        created() {
            this.initialization()
        },

    }
</script>
